const downloadTemplate = (
  event,
  columns,
  filename,
  fieldRequirements = null,
  sampleData = [] // 👈 new param
) => {
  event.preventDefault();

  // Header row
  let headerRow;
  if (
    fieldRequirements &&
    Array.isArray(fieldRequirements) &&
    fieldRequirements.length === columns.length
  ) {
    headerRow = columns
      .map((col, index) => {
        const requirement = fieldRequirements[index] || "";
        return requirement ? `${col} - ${requirement}` : col;
      })
      .join(",");
  } else {
    headerRow = columns.join(",");
  }

  // Sample rows
  const sampleRows = sampleData.length
    ? sampleData
        .map(row =>
          columns.map(col => row[col] ?? "").join(",")
        )
        .join("\n")
    : "";

  // Final CSV
  const csvContent =
    `data:text/csv;charset=utf-8,${headerRow}\n` +
    (sampleRows ? `${sampleRows}\n` : "");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default downloadTemplate;
